// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2M_y_","bigColWidth":"Table_bigColWidth__1ZI2m","biggerColWidth":"Table_biggerColWidth__imA4B","row":"Table_row__tD41F","col":"Table_col__1tlur"};